module.exports = __webpack_public_path__ + "img/logofyfnuevoR.4a1723a6.jpg";